<template>
    <div id="who" class="card who">
      <h2 class="card-h2"><span>Who</span></h2>
      <div class="fetch card-content" v-bind:class="[{'is-loading': isLoading}]">
        <table class="yellow" v-if="hasResults">
          <thead>
            <tr>
              <th>Metric</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value, index) in who">
              <td><i class="material-icons">{{ labels[index].icon }}</i> {{ value !== 1 ? labels[index].plural : labels[index].singular }}</td>
              <td>{{ Number(value).toLocaleString('en-US') }}</td>
            </tr>
          </tbody>
        </table>
        <div v-else>
          <p>No results that match those filters.</p>
        </div>
      </div>
      <div class="loader-dots-wrap center" v-bind:class="[{'is-loading': isLoading}]"><LoaderDots></LoaderDots></div>
    </div>
</template>

<script>
import LoaderDots from '@/components/LoaderDots'

let labels = {
  cyclists: {
    icon: 'directions_bike',
    singular: 'cyclist involved',
    plural: 'cyclists involved'
  },
  hitparkedcar: {
    icon: 'local_parking',
    singular: 'parked car hit',
    plural: 'parked cars hit'
  },
  inattention: {
    icon: 'visibility_off',
    singular: 'cases due to inattention',
    plural: 'cases due to inattention'
  },
  pedestrians: {
    icon: 'directions_walk',
    singular: 'pedestrian involved',
    plural: 'pedestrians involved'
  },
  people: {
    icon: 'person',
    singular: 'person involved',
    plural: 'people involved'
  },
  speeding: {
    icon: 'fast_forward',
    singular: 'case of speeding',
    plural: 'cases of speeding'
  },
  underinfl: {
    icon: 'blur_on',
    singular: 'case under influence of drugs or alcohol',
    plural: 'cases under influence of drugs or alcohol'
  },
  vehicles: {
    icon: 'directions_car',
    singular: 'vehicle involved',
    plural: 'vehicles involved'
  }
}

export default {
  name: 'who',

  components: {
    'LoaderDots': LoaderDots
  },

  data: function () {
    return {
      labels: labels
    }
  },

  computed: {
    hasResults () {
      return (this.who[0] === -1) ? 0 : 1
    },

    isLoading () {
      return (Object.keys(this.who).length === 0) ? 1 : 0
    },

    who () {
      return this.$store.getters['collisionsView/who/get']
    }
  }
}
</script>

<style lang="scss">
@import "./src/sass/components/who";
</style>



// WEBPACK FOOTER //
// Who.vue?1f7cb19c